import { gql } from '@apollo/client';

export const ESTATE_ID_QUERY = gql`
  query GetEstateId($input: GetEstateIdInput!) {
    getEstateId(input: $input)
  }
`;
